import mutations from './mutations'
import actions from './actions'
import getters from './getters'
const state = {
    gifts : localStorage.getItem('gifts') && JSON.parse(localStorage.getItem('gifts'))  || []
};

const module = {
    state,
    getters,
    mutations,
    actions
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/gifts/index.js